import React from 'react';
import Image from 'assets/banner.png';
import { UndraggableImage } from '../shared/UndraggableImage';

export const BannerImage = React.memo(() => {
  return (
    <UndraggableImage
      src={Image}
      width="100%"
      maxWidth="1000px"
      position="relative"
      top={-10}
    />
  );
});
